import React, { useState } from 'react';
import { ArrowRight, Home, Key } from 'lucide-react';
import { Button } from './ui/button';
import InquiryForm from './InquiryForm';

const STRBanner = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900" data-testid="str-banner">
        <div className="absolute inset-0 opacity-15">
          <img
            src="https://images.pexels.com/photos/29025104/pexels-photo-29025104.jpeg?auto=compress&cs=tinysrgb&w=1600"
            alt="Short term rental property"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 container mx-auto px-4 py-12 md:py-16">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Content */}
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-block bg-blue-500/20 border border-blue-400/30 rounded-full px-4 py-1.5 mb-4">
                <span className="text-blue-300 text-sm font-semibold tracking-wide">SHORT-TERM RENTAL EXPERTS</span>
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
                Investing in Short-Term Rentals?<br />
                <span className="text-blue-400">We Specialize in STR Financing.</span>
              </h2>
              <p className="text-gray-300 text-base md:text-lg mb-6 max-w-2xl leading-relaxed">
                Close Now Lending Corp is a trusted leader in DSCR financing for Airbnb, VRBO, and vacation rental investors. Whether you're buying your first STR or scaling a portfolio, we structure loans that work with short-term rental income — no W-2 or tax returns required.
              </p>
              <a href="/short-term-rental" className="inline-flex items-center text-blue-300 hover:text-white font-semibold transition-colors group">
                Learn more about our STR loan programs <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            {/* CTA Cards */}
            <div className="flex flex-col sm:flex-row lg:flex-col gap-4 w-full lg:w-auto lg:min-w-[320px]">
              <a
                href="https://rabbu.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5 hover:bg-white/20 transition-all duration-300 cursor-pointer"
                data-testid="str-rabbu-link"
              >
                <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Home className="h-6 w-6 text-blue-400" />
                </div>
                <div className="flex-1">
                  <p className="text-white font-semibold text-base">Search Short-Term Rentals</p>
                  <p className="text-gray-400 text-sm">Browse STR properties on Rabbu</p>
                </div>
                <ArrowRight className="h-5 w-5 text-gray-400 group-hover:text-white group-hover:translate-x-1 transition-all" />
              </a>

              <button
                onClick={() => setIsFormOpen(true)}
                className="group flex items-center gap-4 bg-blue-600/30 backdrop-blur-sm border border-blue-500/40 rounded-xl p-5 hover:bg-blue-600/50 transition-all duration-300 cursor-pointer w-full text-left"
                data-testid="str-preapproval-btn"
              >
                <div className="w-12 h-12 bg-blue-500/30 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Key className="h-6 w-6 text-blue-300" />
                </div>
                <div className="flex-1">
                  <p className="text-white font-semibold text-base">Get Pre-Approved First</p>
                  <p className="text-blue-200/70 text-sm">Then find your STR investment</p>
                </div>
                <ArrowRight className="h-5 w-5 text-blue-300 group-hover:text-white group-hover:translate-x-1 transition-all" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <InquiryForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        loanType="Short Term Rental"
      />
    </>
  );
};

export default STRBanner;
